import CONSTANTS from '../../store/constants';

export const snackbarOpenAction = (messageId) => {
  return { type: CONSTANTS.OPEN_SNACKBAR, payload: messageId };
};

export const snackbarCloseAction = () => {
  return { type: CONSTANTS.CLOSE_SNACKBAR };
};
